import { atomWithReset } from 'jotai/utils'

import {
  type DisplayRowId,
  type FiveSegmentDisplayColumnKey,
  type FiveSegmentSortColumnKey,
  type NineSegmentDisplayColumnKey,
  type NineSegmentSortColumnKey,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import {
  type Brand,
  type CustomerAttribute,
  type Question,
} from '~/hooks/useSurveyQuery'
import {
  type DataDisplayType,
  type SegmentDisplayType,
  type SortValue,
} from '~/utils'

export const dataDisplayTypeAtom = atomWithReset<DataDisplayType>('percentage')
export const segmentDisplayTypeAtom =
  atomWithReset<SegmentDisplayType>('fiveSegs')
export const brandIdsAtom = atomWithReset<Brand['id'][]>([])
export const questionIdsAtom = atomWithReset<Question['question_id'][]>([])
export const customerAttributeIdsAtom = atomWithReset<
  CustomerAttribute['id'][]
>([])

export const fiveSegmentSortValueAtom =
  atomWithReset<SortValue<FiveSegmentSortColumnKey> | null>(null)
export const nineSegmentSortValueAtom =
  atomWithReset<SortValue<NineSegmentSortColumnKey> | null>(null)

export const hiddenRowIdsAtom = atomWithReset<DisplayRowId[]>([])

// キーはブランドID(文字列化)。useKeyedAtomEntry(~/hooks/jotai) 経由で
// コンポーネント側から出し入れする。
export const fiveSegmentCommentAtom = atomWithReset<
  Partial<Record<string, string>>
>({})
export const savedFiveSegmentCommentAtom = atomWithReset<
  Partial<Record<string, string>>
>({})
export const fiveSegmentHiddenColumnKeysAtom = atomWithReset<
  FiveSegmentDisplayColumnKey[]
>([])
export const nineSegmentCommentAtom = atomWithReset<
  Partial<Record<string, string>>
>({})
export const savedNineSegmentCommentAtom = atomWithReset<
  Partial<Record<string, string>>
>({})
export const nineSegmentHiddenColumnKeysAtom = atomWithReset<
  NineSegmentDisplayColumnKey[]
>([])
